<template>
	<div>
		<xsubcategory></xsubcategory>
	</div>
</template>
<script>
	import xsubcategory from "../component/xsubcategory.vue";
	
	export default{
		 components:{
		 	   xsubcategory,
		 }
	}
</script>


// WEBPACK FOOTER //
// pmine.vue?55c7188e